function r(r,e){return new Proxy(r,{set:function(n,t,u){return"current"===t&&(u!==r.current&&(null!==r.current&&e.unregister(r.current),null!==u&&e.register(u)),n[t]=u,!0)}})}export{r as default};
